<template>
  <section class="data-credibility">
    <div class="data-credibility__bg">
      <img :src="data.bgImage" alt="" />
    </div>

    <div class="data-credibility__title-area">
      <span class="data-credibility__label">{{ data.label }}</span>
      <h2 class="data-credibility__title">{{ data.title }}</h2>
    </div>

    <div class="data-credibility__body">
      <div class="data-credibility__metrics">
        <div
          v-for="(row, rowIndex) in metricRows"
          :key="rowIndex"
          class="data-credibility__metrics-row"
        >
          <div
            v-for="(metric, colIndex) in row"
            :key="colIndex"
            class="data-credibility__metric-card"
          >
            <span class="data-credibility__metric-value">{{
              metric.value
            }}</span>
            <span class="data-credibility__metric-label">{{
              metric.label
            }}</span>
          </div>
        </div>
      </div>

      <div class="data-credibility__trend">
        <span class="data-credibility__trend-label">{{ data.trendLabel }}</span>
        <p class="data-credibility__trend-desc">{{ data.trendDescription }}</p>
        <div class="data-credibility__chart">
          <div
            v-for="(bar, index) in data.chartBars"
            :key="index"
            class="data-credibility__bar"
            :style="{ height: bar.height + 'px', backgroundColor: bar.color }"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DataCredibility",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    metricRows() {
      const rows = [];
      for (let i = 0; i < this.data.metrics.length; i += 2) {
        rows.push(this.data.metrics.slice(i, i + 2));
      }
      return rows;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.data-credibility {
  position: relative;
  padding: 56px 40px;
  box-sizing: border-box;
  overflow: hidden;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__title-area {
    position: relative;
    margin-bottom: 26px;
  }

  &__label {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #d7c08f;
    letter-spacing: 1.5px;
    text-align: left;
    display: block;
  }

  &__title {
    font-family: $font-family;
    font-size: 46px;
    font-weight: 700;
    color: #fff;
    margin: 0;
    text-align: left;
  }

  &__body {
    position: relative;
    display: flex;
  }

  &__metrics {
    width: 520px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    margin-right: 22px;
  }

  &__metrics-row {
    display: flex;

    .data-credibility__metric-card {
      margin-right: 18px;
    }

    .data-credibility__metric-card:last-child {
      margin-right: 0;
    }
  }

  &__metrics-row + .data-credibility__metrics-row {
    margin-top: 18px;
  }

  &__metric-card {
    flex: 1;
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 77px;
  }

  &__metric-value {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    color: #fff;
    display: block;
    margin-bottom: 6px;
    text-align: left;
  }

  &__metric-label {
    font-family: $font-family;
    font-size: 13px;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.72);
    display: block;
    text-align: left;
  }

  &__trend {
    flex: 1;
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.055);
    border: 1px solid rgba(255, 255, 255, 0.094);
    padding: 22px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  &__trend-label {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #d7c08f;
    letter-spacing: 1.2px;
    display: block;
    margin-bottom: 18px;
    text-align: left;
  }

  &__trend-desc {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.72);
    line-height: 1.72;
    margin: 0 0 18px 0;
    text-align: left;
  }

  &__chart {
    display: flex;
    align-items: flex-end;
    flex: 1;

    .data-credibility__bar {
      flex: 1;
      border-radius: 8px;
      margin-right: 18px;
      box-sizing: border-box;
    }

    .data-credibility__bar:last-child {
      margin-right: 0;
    }
  }
}

// 平板适配
@media (max-width: 1199px) and (min-width: 768px) {
  .data-credibility {
    padding: 48px 32px;

    &__title {
      font-size: 38px;
    }

    &__metrics {
      width: 420px;
      margin-right: 18px;
    }
  }
}

// 手机适配
@media (max-width: 767px) {
  .data-credibility {
    padding: 32px 20px;

    &__title-area {
      margin-bottom: 16px;
    }

    &__label {
      font-size: 11px;
    }

    &__title {
      font-size: 30px;
    }

    &__body {
      flex-direction: column;
    }

    &__metrics {
      width: 100%;
      margin-right: 0;
      margin-bottom: 16px;
    }

    &__metrics-row {
      .data-credibility__metric-card {
        margin-right: 12px;
      }
    }

    &__metrics-row + .data-credibility__metrics-row {
      margin-top: 12px;
    }

    &__metric-value {
      font-size: 24px;
    }

    &__trend-label {
      font-size: 11px;
      margin-bottom: 12px;
    }

    &__trend-desc {
      font-size: 13px;
      margin-bottom: 12px;
    }

    &__chart .data-credibility__bar {
      margin-right: 12px;
    }
  }
}
</style>
